import { render, staticRenderFns } from "./CustomizeMetalR.vue?vue&type=template&id=ddd99f0c&scoped=true"
import script from "./CustomizeMetalR.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalR.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalR.vue?vue&type=style&index=0&id=ddd99f0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd99f0c",
  null
  
)

export default component.exports